import React from 'react';
import { domainConfig } from 'src/helpers/domainConfig';

import DefPrivacy from './def';
import LaserPrivacy from './laserprofit';

class Terms extends React.Component {
  render() {
    return domainConfig.title !== 'LaserProfit' ? <DefPrivacy /> : <LaserPrivacy />;
  }
}
export default Terms;
